import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import _ from 'lodash'

export const mapStateToProps = (state) => ({
    accessRights: state.getIn(['authorization', 'accessRights']),
    hasImporterRights: state.getIn(['authorization', 'importer', 'available']),
})

export default (SecuredComponent) => {
    @connect(mapStateToProps)
    class HocAcl extends Component {
        static propTypes = {
            accessRights: PropTypes.object.isRequired,
            hasImporterRights: PropTypes.bool.isRequired,
        }

        hasRights = (key = null) => {
            const { accessRights, hasImporterRights } = this.props

            if (key === 'all') return true
            if (key === 'importer') return hasImporterRights
            if (_.isArray(key)) return _.some(key, (k) => this.hasRights(k))

            return !!accessRights.getIn([key, 'hasRights'])
        }

        render() {
            return <SecuredComponent {...this.props} hasRights={this.hasRights} />
        }
    }

    return HocAcl
}

export const hasRightsSelector = (state, module) => state.getIn(['authorization', 'accessRights', module, 'hasRights'])
